<template lang="html">
  <nav :class="{ active: isActive }">
    <div class="mobile no-select" @click="isActive = !isActive">
    </div>
    <div class="menu no-select" @click="isActive = !isActive">
      <router-link v-if="isActive" :to="{ name: 'home' }" class="so-logo no-select">
        SO <span class="title">REPRESENT</span>
      </router-link>
      <router-link :to="{ name: 'home' }">News</router-link>
      <router-link :to="{ name: 'artists' }">Artists</router-link>
      <router-link :to="{ name: 'production' }">Production</router-link>
      <router-link :to="{ name: 'about' }">About</router-link>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isActive: false
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
    padding: 1.3rem 1.5rem 1.4rem;
    z-index: 999;
    pointer-events: auto;
    .mobile {
        display: none;
        position: absolute;
        top: 1.7rem;
        right: 1.5rem;
        z-index: 999;
        width: var(--lh);
        height: var(--lh);
        cursor: pointer;
        border-bottom: 1px solid black;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 0;
            border-bottom: 1px solid black;
        }
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 0;
            border-bottom: 1px solid black;
        }
    }
    .menu {
        display: block;
        .so-logo {
            display: none;
        }
    }
    &.active {
        .menu {
            display: block;
            .so-logo {
                display: none;
            }
        }
    }
    a {
        display: block;
        text-align: right;
        &.router-link-exact-active {
            font-family: "Kolektiv-LightItalic", Times, serif;
        }
    }
    @media only screen and (max-width:768px) {
        .mobile {
            display: block;
        }
        .menu {
            display: none;
            a {
                text-align: left;
            }
            .so-logo {
                display: none;
                padding: 0 !important;
                .title {
                    font-family: "SORepresent-Light", Times, serif;
                    font-feature-settings: normal;
                    font-size: calc(1.9 * var(--fs));
                    text-transform: uppercase;
                    letter-spacing: 0.025em;
                    line-height: 1;
                }
            }
        }
        &.active {
            position: fixed;
            background: rgba(255,255,255,1);
            top: 0;
            left: 0;
            z-index: 0;
            padding: 1.3rem 1.5rem 1.5rem;
            width: 100%;
            height: 100%;
            .mobile {
                border-bottom: 0;
                top: 1.6rem;
                &:after,
                &:before {
                    top: 50%;
                }
                &:before {
                    transform: rotate(45deg) translateX(0.5px);
                }
                &:after {
                    transform: rotate(-45deg);
                }
            }
            .menu {
                display: block;
                font-size: calc(4.5 * var(--fs));
                line-height: 1;
                .so-logo {
                    display: block;
                    .title {
                        padding-left: 0.15rem;
                    }
                }
            }
        }
    }
}
</style>
